import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { registerWorkforceLocaleData } from './app/providers/app-locale.providers';
import { initWorkforceSentry } from './config/sentry-env';

// Same binding order as Sentry’s Angular sample: init SDK, then bootstrap.
initWorkforceSentry();
registerWorkforceLocaleData();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
